// Class: openfl.events.UncaughtErrorEvents

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../hxClasses_stub").default;
var $hxEnums = require("./../../hxEnums_stub").default;
var $import = require("./../../import_stub").default;
var $extend = require("./../../extend_stub").default;
function openfl_events_EventDispatcher() {return require("./../../openfl/events/EventDispatcher");}

// Constructor

var UncaughtErrorEvents = function() {
	(openfl_events_EventDispatcher().default).call(this);
}

// Meta

UncaughtErrorEvents.__name__ = "openfl.events.UncaughtErrorEvents";
UncaughtErrorEvents.__isInterface__ = false;
UncaughtErrorEvents.__super__ = (openfl_events_EventDispatcher().default);
UncaughtErrorEvents.prototype = $extend((openfl_events_EventDispatcher().default).prototype, {
	
});
UncaughtErrorEvents.prototype.__class__ = UncaughtErrorEvents.prototype.constructor = $hxClasses["openfl.events.UncaughtErrorEvents"] = UncaughtErrorEvents;

// Init



// Statics




// Export

exports.default = UncaughtErrorEvents;